<template>
  <div class="CuratedList">
    <div class="container" :class="{'hiddenPrevButton': this.activeSlider ===0 }">
      <h3 v-if="data.title">{{data.title}}</h3>
      <Slick
        ref="slick"
        class="carousel"
        :options="{
          swipe: true,
          swipeToSlide: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows:true,
          prevArrow: `<button type='button' class='slick-prev prev'></button>`,
          nextArrow: `<button type='button' class='slick-next next'></button>`,
          pauseOnFocus: true,
          autoplay: false,
          lazyLoad: false,
          responsive: [
            {
              breakpoint: mobileDeviceScreenSize,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false,
              }
            },
          ]
        }"
        @afterChange="handleAfterChange">
        <div
          v-for="(item,index) in data.bannerList"
          :key="index"
          class="item">
          <a :href="item.bannerLink"
             class="label">
            <imageView
              :image="item.banner"
              :desiredSize="getImageSize"
            />
          </a>
        </div>
      </Slick>
    </div>
  </div>
</template>

<script>
    import Slick from 'vue-slick';

    import imageView from "../../components/imageView/imageView";

    import {DEVICES, MOBILE_DEVICE_SCREEN_SIZE} from '../../common/constants/constants';

    export default {
        name: "CuratedList",
        props: {
            data: Object,
        },
        data() {
            return {
                mobileDeviceScreenSize: MOBILE_DEVICE_SCREEN_SIZE[DEVICES.PHONE],
                activeSlider: 0,
            };
        },
        computed: {
            getImageSize: function () {
                return {
                    width: 386,
                    height: 217,
                };
            },
        },
        methods: {
            handleAfterChange(event, slick, currentSlide) {
                this.activeSlider = currentSlide;
                const bannerlength = this.data.bannerList.length;
                if (currentSlide === bannerlength - 3) {
                    this.$refs.slick.goTo(0);
                }
                window.dispatchEvent(new CustomEvent('scroll'))
            },
        },
        components: {
            Slick,
            imageView,
        }
    };
</script>

<style src="./CuratedList.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/partials/CuratedList/CuratedList.vue